import UnitSelect from './Index.vue'
UnitSelect.install = function(Vue) {
  Vue.component(UnitSelect.name, UnitSelect)
}

export default UnitSelect
